export const opciones: string[] = [
  "Información",
  "Horarios",
  "Imagenes"
]
